document.addEventListener("sections:loaded", () => {
  if (typeof EmblaCarousel === "undefined") {
    return;
  }

  document.querySelectorAll("[data-testimonial-carousel]").forEach((root) => {
    const viewport = root.querySelector(".embla__viewport");
    const section = root.closest(".section-testimonial");

    if (!viewport || !section) {
      return;
    }

    const slideCount = viewport.querySelectorAll(".embla__slide").length;
    if (slideCount < 2) {
      return;
    }

    const embla = EmblaCarousel(viewport, {
      loop: true,
      align: "start",
    });

    const prevButton = section.querySelector(".carousel-prev");
    const nextButton = section.querySelector(".carousel-next");

    prevButton?.addEventListener("click", () => embla.scrollPrev());
    nextButton?.addEventListener("click", () => embla.scrollNext());
  });
});
